<div class="dropzone" [class.dropzone--hover]="hover">
  <div class="d-flex">
    <span inlineSVG="/assets/svg/upload-file.svg" class="dropzone__icon"></span>
    <label class="dropzone__label c-pointer" [attr.for]="fileId"><span>Click here to upload file</span></label>
  </div>
  <input type="file" multiple [formControl]="fileControl" [attr.name]="fileId" [attr.id]="fileId">
  <p *ngIf="showTypes">Allowed types: {{typeStr}}</p>
</div>